<template>
    <TotemTreeSelect
        :options="categoriesOptions"
        :placeholder="$t('CourseListFilter.categories')"
        @input="selectCategoryOption"
        class="filter-select"
        :selectedOptions="selectedOptions"
        v-on:deselectOption="onDeselectOption"
        v-on:deselectAll="onDeselectAll"
    />
</template>

<script>
    import { mapGetters } from 'vuex'
    import TotemTreeSelect from 'components/user/shared/totem-tree-select'
    import { uniqBy } from 'lodash'

    export default {
        name: 'CategoriesFilter',
        components: {
            TotemTreeSelect
        },
        props: {
            entityList: Array
        },
        computed: {
            ...mapGetters({
                filteredCategoryTree: 'CourseFilter/getFilteredCategories',
                selectedOptions: 'CourseFilter/getSelectedCategories'
            }),
            categoriesOptions () {
                const uniqueCategories = uniqBy(
                    this.entityList.reduce((categories, entity) => {
                        return categories.concat(entity.categories)
                    }, []),
                    'id'
                )
                return this.filteredCategoryTree(uniqueCategories)
            }
        },
        methods: {
            filterByCategories (data) {
                if (this.selectedOptions.length === 0) {
                    return data
                }
                return data.filter(entity => {
                    return this.selectedOptions.reduce((acc, option) => {
                        return acc & !!entity.categories.find(category => +category.id === +option.id)
                    }, true)
                })
            },
            selectCategoryOption (option) {
                this.$store.dispatch('CourseFilter/addSelectedOption', option)
            },
            onDeselectOption (node) {
                this.removeTag(node)
            },
            onDeselectAll (node) {
                this.$store.dispatch('CourseFilter/removeAllCategoriesOptions')
            },
            removeTag (option) {
                this.$store.dispatch('CourseFilter/removeSelectedOption', option)
            }
        }
    }
</script>
